import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface SplashContextType {
  /** true once the intro has finished (or was skipped) */
  done: boolean;
  finish: () => void;
}

const SplashContext = createContext<SplashContextType>({ done: true, finish: () => {} });
export const useSplash = () => useContext(SplashContext);

export const SplashProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [done, setDone] = useState(false);
  const finish = useCallback(() => setDone(true), []);
  return <SplashContext.Provider value={{ done, finish }}>{children}</SplashContext.Provider>;
};
